module.exports = __webpack_public_path__ + "static/media/iOSlogo.90ed06ae.svg";